module.exports = __webpack_public_path__ + "img/our-partners-3.b33d1e9e.jpg";